import { addDays } from 'date-fns'

/**
 * 入力された日付のnextNum分翌日の日付を返す
 *  ex) formatPrevDate(new Date("2022/04/14"), 1) => Fri Apr 13 2022 00:00:00 GMT+0900 (日本標準時)
 */
export const formatPrevDate = (date: Date, prevNum: number) => {
  return addDays(date, -prevNum)
}
